export default "__VITE_ASSET__Dkq7l8hx__"